// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("@rescript/std/lib/js/curry.js");
var React = require("react");
var Context = require("../../../provider/Context.bs.js");
var Atom_Box = require("../../atom/Atom_Box.bs.js");
var Atom_Cta = require("../../atom/Atom_Cta.bs.js");
var SetFocus = require("../../../hook/SetFocus.bs.js");
var Caml_option = require("@rescript/std/lib/js/caml_option.js");
var User_Provider = require("../../../user/User_Provider.bs.js");
var Molecule_Badge = require("../../molecule/Molecule_Badge.bs.js");
var Organism_Tooltip = require("../Organism_Tooltip.bs.js");
var Particle_Screen_Ds = require("../../particle/Particle_Screen_Ds.bs.js");
var UseTrackingAmplitude = require("../../../hook/UseTrackingAmplitude.bs.js");

function Organism_LoginButton(Props) {
  var forcedUserStatus = Props.forcedUserStatus;
  var labels = Props.labels;
  var searchState = Props.searchState;
  var settingsHref = Props.settingsHref;
  var trackAmplitude = UseTrackingAmplitude.useUserAction("login_button");
  var match = Context.I18n.getState(undefined);
  var userStatus = Curry._1(User_Provider.Hook.useUserStatus, undefined);
  var userContextStatus = Curry._1(User_Provider.Hook.useStatus, undefined);
  var internalAuthEnabled = Context.Config.getFeatureFlippingStatus(/* InternalAuth */9);
  var userStatus$1 = forcedUserStatus !== undefined ? forcedUserStatus : userStatus;
  var paramButtonId = "param_button";
  var loginButtonId = "login-button";
  var match$1 = React.useState(function () {
        return /* Hide */1;
      });
  var setTooltipStatus = match$1[1];
  var match$2 = userStatus$1 !== 0 ? [
      undefined,
      undefined
    ] : [
      (function (param) {
          Curry._1(setTooltipStatus, (function (param) {
                  return /* Show */0;
                }));
        }),
      (function (param) {
          Curry._1(setTooltipStatus, (function (param) {
                  return /* Hide */1;
                }));
        })
    ];
  var label = userStatus$1 !== 1 ? labels.login : labels.pseudo;
  var href = internalAuthEnabled ? match.myArteUrl : (
      userStatus$1 !== 1 ? match.loginUrl : match.profileUrl
    );
  var labels$1 = Particle_Screen_Ds.make(undefined, undefined, undefined, Caml_option.some(label), undefined, "");
  var userPrefOnClose = function (param) {
    Curry._1(setTooltipStatus, (function (param) {
            return /* Hide */1;
          }));
  };
  var displayMobileRules = searchState ? Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "flex") : Particle_Screen_Ds.make(undefined, undefined, undefined, "flex", undefined, "none");
  var onFocus = function (param) {
    if (userStatus$1 !== 0) {
      return ;
    } else {
      return Curry._1(setTooltipStatus, (function (param) {
                    return /* Show */0;
                  }));
    }
  };
  var onBlur = function (param) {
    if (userStatus$1 !== 0) {
      return ;
    } else {
      return SetFocus.ById.make(paramButtonId);
    }
  };
  var onClick = function (param) {
    Curry._1(trackAmplitude, undefined);
  };
  var cta = React.createElement(Atom_Cta.Link.Responsive.make, {
        href: href,
        id: loginButtonId,
        labels: labels$1,
        onBlur: onBlur,
        onClick: onClick,
        onFocus: onFocus,
        screenReadersLabel: label,
        style: {
          TAG: /* Header */10,
          _0: {
            TAG: /* User */11,
            _0: displayMobileRules
          }
        }
      });
  var tmp = {
    children: userContextStatus || userStatus$1 !== 0 ? cta : React.createElement(Organism_Tooltip.UserPref.make, {
            status: match$1[0],
            onClose: userPrefOnClose,
            children: React.createElement(Molecule_Badge.make, {
                  style: /* LoginButton */0,
                  children: cta
                }),
            loginButtonId: loginButtonId,
            paramButtonId: paramButtonId,
            settingsHref: settingsHref
          })
  };
  var tmp$1 = match$2[0];
  if (tmp$1 !== undefined) {
    tmp.onMouseEnter = Caml_option.valFromOption(tmp$1);
  }
  var tmp$2 = match$2[1];
  if (tmp$2 !== undefined) {
    tmp.onMouseLeave = Caml_option.valFromOption(tmp$2);
  }
  return React.createElement(Atom_Box.make, tmp);
}

var make = Organism_LoginButton;

exports.make = make;
/* react Not a pure module */
